import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { headers } from 'src/app/general/helpers/headers.helper';
import { User, UserInterface, UserResponse, UsersListResponse } from './interface/user.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  url = environment.APP_ENDPOINT;

  constructor(private http: HttpClient) { }

  getUsers(): Observable<UsersListResponse> {
    return this.http.get<UsersListResponse>(this.url + 'users/list', { headers: headers() })
  }

  getUsersForInvoices(name: string): Observable<UserInterface[]> {
    return this.http.get<UsersListResponse>(this.url + 'users/list?name=' + name , { headers: headers() }).pipe(map(res => res.data))
  }

  createUser(body: User): Observable<UserResponse> {
    return this.http.post<UserResponse>(this.url + 'registration', body, { headers: headers() })
  }

  updateUser(body: User, id: number): Observable<UserResponse> {
    return this.http.post<UserResponse>(this.url + `user/update/${id}`, body, {headers: headers()});
  }

  deleteUser(id: number): Observable<UserResponse> {
    return this.http.delete<UserResponse>(this.url + `user/delete/${id}`, {headers: headers()});
  }

  getRoles(): Observable<any> {
    return this.http.get<any>(this.url + 'roles/list', { headers: headers() })
  }

  getInstallers(): Observable<any> {
    return this.http.get<any>(this.url + 'users/installers/select', { headers: headers() })
  }

  getZohoOwners(): Observable<any> {
    return this.http.get<any>(this.url + 'users/zoho-owners/select', { headers: headers() })
  }

  getTeamUpWho(): Observable<any> {
    return this.http.get<any>(this.url + 'users/teamup-who/select', { headers: headers() })
  }

  getDesigners(): Observable<UserInterface[]> {
    return this.http.get<UsersListResponse>(this.url + 'users/list?role_id=6', { headers: headers() }).pipe(map(res => res.data))
  }
}
